import { render, staticRenderFns } from "./WidgetsReportPayslip.vue?vue&type=template&id=0dfa862e&scoped=true"
import script from "./WidgetsReportPayslip.vue?vue&type=script&lang=js"
export * from "./WidgetsReportPayslip.vue?vue&type=script&lang=js"
import style0 from "./WidgetsReportPayslip.vue?vue&type=style&index=0&id=0dfa862e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dfa862e",
  null
  
)

export default component.exports